module.exports = __webpack_public_path__ + "index/img/fenxiang.18bda8d3.png";